import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, description, align = "left", testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    <Reveal>
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#2E8B57]">{overline}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-heading mt-4 text-3xl font-semibold leading-[1.15] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">{description}</p>
      </Reveal>
    )}
  </div>
);
